import { graphql, Link, useStaticQuery } from 'gatsby';
import React, { useState } from 'react';
import Form from 'react-bootstrap/Form';
import { useFlexSearch } from 'react-use-flexsearch';
import moment from 'moment';
import SearchItem from '../parts/SearchItem';

export default function SearchBar(){
  // const { search } = window.location;
  // const query = new URLSearchParams(search).get('s')
  const [searchQuery, setSearchQuery] = useState('');
  const data = useStaticQuery(
    graphql`
      query {
        localSearchPages {
          index
          store
        }
      }  
    `
  )
  const results = useFlexSearch(
    searchQuery, 
    data.localSearchPages.index, 
    data.localSearchPages.store
  );
  console.log(results);
  return (
    <>
      <Form>
        <Form.Group className="mb-3">
          <Form.Label>検索キーワード</Form.Label>
          <Form.Control
            ref={(input) => { if (input) { input.focus();} }}
            defaultValue={searchQuery}
            onChange={(e) => {
              e.preventDefault();
              setSearchQuery(e.currentTarget.value)
            }}
            onSubmit={(e) => {
              e.preventDefault();
              setSearchQuery(e.currentTarget.value)
            }}
            type="text"
            id="header-search"
            placeholder="検索キーワード"
            name="s"
          />
        </Form.Group>
        <Form.Group className="mb-3">
          <Form.Label>検索結果</Form.Label>
          {results.map(post => (
            <SearchItem data={post} key={post.id} />
            // <div key={post.id}>
            //   <h2>
            //     { post.posttype === 'issue' ? (
            //       <Link to={`/issue/${post.filename}`}>[問題解決]{post.title}</Link>
            //     ) : (
            //       <Link to={`/${post.slug}`}>{post.title}</Link>
            //     )}
            //   </h2>
            //   <div className='post-meta'>
            //     <span className='date'>{moment(post.date).format(`YYYY年M月D日 H:mm`)} </span>
            //     <br />
            //   </div>
            // </div>
          ))}
        </Form.Group>
      </Form>
    </>
  )
}